import InfoPage from "@/pages/InfoPage";

export default function AccessibilityStatement() {
  return (
    <InfoPage
      testId="accessibility-statement-page"
      eyebrow="Important Information"
      title="Accessibility Statement"
      intro="AGS Cleaning Services is committed to making our website usable by the widest possible audience, regardless of ability or technology. We aim to comply with WCAG 2.2 Level AA and the European Accessibility Act."
      sections={[
        {
          heading: "1. What we do",
          body: "We design and develop ags-services.ie with accessibility in mind from the outset.",
          list: [
            "Semantic HTML structure and ARIA labels where needed",
            "Sufficient colour contrast between text and background",
            "Visible keyboard focus states throughout the site",
            "Descriptive alt text on all meaningful imagery",
            "Forms with associated labels and helpful error messaging",
            "Resizable text up to 200% without loss of content",
            "Responsive layout for mobile, tablet, and desktop",
          ],
        },
        {
          heading: "2. Known limitations",
          body: "We are continuously improving. Known areas under review:",
          list: [
            "Some third-party embeds (maps, videos) may have inconsistent accessibility — we will replace or supplement these where needed",
            "PDF documents linked from this site may not always be fully tagged for screen readers",
          ],
        },
        {
          heading: "3. Reporting issues & getting support",
          body: "If you encounter any accessibility barrier on our website, or if you need information from this site in an alternative format (large print, audio, plain text), please contact us:",
          list: [
            "Email: info@ags-services.ie",
            "Phone: +353 87 381 6923",
            "We aim to respond within 5 business days.",
          ],
        },
        {
          heading: "4. Enforcement",
          body: "If you are not satisfied with our response, you may contact the National Disability Authority (nda.ie) for guidance.",
        },
      ]}
    />
  );
}
